import PropTypes from "prop-types";

import { popoutContainerCss } from "../../SecondaryActions.style";
import FontSizeOption from "../FontSizeOption/FontSizeOption";
import { sizeOptions } from "../sizeOptions";

const propTypes = {
  contentId: PropTypes.string,
  currentFontSize: PropTypes.string,
  isMobile: PropTypes.bool,
  setCurrentFontSize: PropTypes.func,
};

const FontSizeOptions = ({
  contentId,
  currentFontSize,
  isMobile,
  setCurrentFontSize,
}) => {
  const renderPopoutContents = () => {
    return Object.keys(sizeOptions).map((option) => {
      const optionName = sizeOptions[option].buttonLabel;

      return (
        <FontSizeOption
          key={option}
          contentId={contentId}
          isSelected={currentFontSize === option}
          name={optionName}
          option={option}
          setCurrentFontSize={setCurrentFontSize}
        />
      );
    });
  };

  if (isMobile) return renderPopoutContents();

  return (
    <ul role="list" css={popoutContainerCss}>
      {renderPopoutContents()}
    </ul>
  );
};

FontSizeOptions.propTypes = propTypes;

export default FontSizeOptions;
